import { PAGE_LOADER, DASHBOARD_CONTAINER } from '../../../../types/types';
import { CARD_FORM } from '../form-card-type';
import { showToast } from '../../../toasts';
import { dropdown } from '../../../dropdown';

import { ICustomers } from '../../../../models/customer.interface';
import { ICardGroupInsertUpdate } from '../../../../models/cardgroup.interface';
import { INewPartner } from '../../../../models/partner.interface';
import GetPartners from '../../../../routes/get-partners';
import GetCustomers from '../../../../routes/get-customers';
import GetCardGroups from '../../../../routes/get-card-groups';

/**
 * Function to populate the partner dropdown
 * 
 * @returns void
 */
export const populatePartnerDropdown = async () => {
  const { body } = await GetPartners();

  if ( !Array.isArray(body) || body.length === 0 ) {
    showToast('aafp_toast-alert', 'Error getting partner data');
  } else {
    const mapList = body.map((r: INewPartner) => ({ id: r.partnerID, name: r.partnerName }));
    dropdown(mapList, 'partner', 'Partner', true, true, true);
    DASHBOARD_CONTAINER.removeAttribute('style');
    PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  }
};

/**
 * Function to populate the customer dropdown
 * 
 * @param {string} partnerId the partner id
 * @param {string} partnerName the partner name
 * 
 * @returns void
 */
export const populateCustomerDropdown = async (partnerId: string, partnerName: string) => {
  const { body } = await GetCustomers(partnerId);

  if ( !Array.isArray(body) || body.length === 0 ) {
    showToast('aafp_toast-alert', `No customers found for ${partnerName}.`);
    CARD_FORM.cardCustomer.innerText = 'Please Select A Partner';
  } else {
    const mapList = body
          .map((r: ICustomers) => ({ id: r.customerId, name: r.customerName }))
          .sort((a, b) => a.name.localeCompare(b.name));
    dropdown(mapList, 'customer', 'Customer', true, true, true);
    CARD_FORM.cardCustomer.innerText = 'Please Select A Customer';
  }
};

/**
 * Function to populate the card group dropdown
 * 
 * @param {string} customerId the customer id
 * @param {string} customerName the customer name
 * 
 * @returns void
 */
export const populateCardGroupDropdown = async (customerId: string, customerName: string) => {
  const { body } = await GetCardGroups(customerId);

  if ( !Array.isArray(body) || body.length === 0 ) {
    showToast('aafp_toast-alert', `No card groups found for ${customerName}.`);
    CARD_FORM.cardCardGroup.innerText = 'Please Select A Customer';
  } else {
    const mapList = body
          .map((r: ICardGroupInsertUpdate) => ({ id: r.cardGroupId, name: r.cardGroupName }))
          .sort((a, b) => a.name.localeCompare(b.name));
    dropdown(mapList, 'card-group', 'Card Group', true, true, true);
    CARD_FORM.cardCardGroup.innerText = 'Please Select A Card Group';
  }
};